import React, { useRef } from 'react';
import './ImageBar.css';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import {
  toggleFullSize,
  setShowImages
} from '../state/uiControl/uiControl.actions';
import down from '../assets/images/down.svg';
import up from '../assets/images/up.svg';
import left from '../assets/images/left.svg';
import right from '../assets/images/right.svg';
import { isMobile } from '../util';
import { Display } from '../state/uiControl/uiControl.reducer';
import { Files, Ref } from "../services/types";

//http://10.20.1.23:8080/anchor/api/content/seabourn/entries/c55c169d32d444cba1e5d24e86d0f08f/12a2bd5b6753a1df424b145d58cfa086_7d746eeb-036e-43c3-a9f6-5b15f7815492.jpg

const BASE_PATH = 'https://' + process.env.REACT_APP_CMS_DOMAIN + '/anchor/api/';

/**
 * It might look redundant, but by using the "Object.values" method
 * to get an array of objects, the order alternates.
 * @param images object of Files
 * @return sortedImagesArray Ref[]
 */
export const sortedImagesByKeys = (images: Files): Ref[] => {
  const sortedKeys = Object.keys(images).sort();
  const sortedImagesArray: Ref[] = [];
  for (const key of sortedKeys){
    sortedImagesArray.push({...images[key]});
  }
  return sortedImagesArray;
};

export const ImageBar = ({
  selected,
  toggleFullSize,
  selectedImage,
  setShowImages,
  children,
}: ImageBarProps) => {
  const images = selected && selected.files ? sortedImagesByKeys(selected.files) : [];
  const lastImage = useRef<HTMLImageElement>(null);
  const firstImage = useRef<HTMLImageElement>(null);

  //Hides image is link does not work
  document.addEventListener("DOMContentLoaded", function (event) {
    document.querySelectorAll('img').forEach(function (img) {
      img.onerror = function () { this.style.display = 'none'; };
    });
  });


  if (!selected || !selected.files || !images.length) return <div />;

  if (isMobile() && !selectedImage) toggleFullSize(BASE_PATH + images[0].path);


  return (
    <div className='bar'>
      {children}
      <div className="arrows">
        <img
          alt="previous"
          className='arrowIcon' src={isMobile() ? left : up}
          onClick={() => firstImage.current?.scrollIntoView({ behavior: 'smooth' })}
        />
      </div>
      <div
        className='scrollableContainer'
        onClick={() => {
          if (isMobile()) { setShowImages(false); }
        }}>
        {!!images && images.map((image: Ref, index: number) => {
          let ref;
          if (index === 0) {
            ref = firstImage;
          } else if (index === images.length - 1) {
            ref = lastImage;
          }
          return (
            <img
              ref={ref}
              key={image.path}
              alt="thumbnail"
              className='thumbnail'
              src={BASE_PATH + image.path}
              onClick={(e) => {
                toggleFullSize(BASE_PATH + image.path);
                e.stopPropagation();
              }}
            />
          );
        })}
      </div>
      <div className="arrows">
        <img
          alt="next"
          className='arrowIcon' src={isMobile() ? right : down}
          onClick={() => lastImage.current?.scrollIntoView({ behavior: 'smooth' })}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps: any) => {
  let selected;

  switch (state.uiControl.showing) {
  case Display.PORT:
    selected = state.uiControl.selectedPort;
    break;
  case Display.ENTRY:
    selected = state.uiControl.selectedEntry;
    break;
  case Display.SPECIES:
    selected = state.uiControl.selectedSpecies;
    break;
  case Display.BULLETIN:
    selected = state.uiControl.selectedBulletin;
    break;
  }
  
  return {
    children: ownProps.children,
    selectedImage: state.uiControl.selectedImage,
    selected: selected,
  };
};

const dispatchProps = {
  toggleFullSize,
  setShowImages
};

type ImageBarProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(ImageBar);